import { render, staticRenderFns } from "./OnlineTeaching.vue?vue&type=template&id=4a89a136&scoped=true&"
import script from "./OnlineTeaching.vue?vue&type=script&lang=js&"
export * from "./OnlineTeaching.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTeaching.vue?vue&type=style&index=0&id=4a89a136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89a136",
  null
  
)

export default component.exports